<template>
  <svg
    :class="svgClass"
    :width="sizes[0]"
    :height="sizes[1]"
    fill="currentcolor"
    aria-hidden="true"
    v-on="$listeners"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: "RbdSvgIcon",
  props: {
    icon: {
      type: String,
      default: "code-yes",
      require: true,
    },
    className: {
      type: String,
      default: "",
    },
    sizes: {
      type: Array,
      default() {
        return ["1em", "1em"];
      },
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.icon}`;
    },
    svgClass() {
      return "rbd-svg-icon " + this.className;
    },
  },
};
</script>

<style lang="scss" scoped></style>
